export default __webpack_public_path__ + "static/media/LenovoSlim1.d391d51c.jpg";